<template>
  <basic-block :title="currentTerm.termName">
    <template #search>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-select
            :size="$publicConfig.selectSize"
            v-model="search.campusCode"
            placeholder="请选择校区"
            @change="allSchools"
          >
            <el-option
              v-for="item in allschool"
              :key="item.campusCode"
              :label="item.campusName"
              :value="item.campusCode"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="search.date"
            :size="$publicConfig.selectSize"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
            @change="studentCheckRecordStatistics"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </template>
    <el-row :gutter="24">
      <el-col :span="10" style="height: 440px">
        <bar :barData="countState"></bar>
      </el-col>

      <el-col :span="14" style="height: 440px">
        <div id="grade_statistic" class="charts"></div>
      </el-col>

      <el-col :span="24">
        <el-table :data="tableData" style="width: 100%" stripe>
          <el-table-column prop="grade" label="年级"></el-table-column>
          <el-table-column prop="studentAmount" label="学生人数">
          </el-table-column>
          <el-table-column
            prop="totalCount"
            label="考勤总人次"
          ></el-table-column>
          <el-table-column prop="onTime" label="准时">
            <template scope="scope">
              <span>
                {{ scope.row.onTime }} ({{
                  scope.row.totalCount > 0
                    ? ((scope.row.onTime / scope.row.totalCount) * 100).toFixed(
                        2
                      ) + '%'
                    : '0.00%'
                }})
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="late" label="迟到">
            <template scope="scope">
              <span>
                {{ scope.row.late }} ({{
                  scope.row.totalCount > 0
                    ? ((scope.row.late / scope.row.totalCount) * 100).toFixed(
                        2
                      ) + '%'
                    : '0.00%'
                }})
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="leave" label="请假">
            <template scope="scope">
              <span>
                {{ scope.row.leave }} ({{
                  scope.row.totalCount > 0
                    ? ((scope.row.leave / scope.row.totalCount) * 100).toFixed(
                        2
                      ) + '%'
                    : '0.00%'
                }})
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="notArrive" label="缺勤">
            <template scope="scope">
              <span>
                {{ scope.row.notArrive }} ({{
                  scope.row.totalCount > 0
                    ? (
                        (scope.row.notArrive / scope.row.totalCount) *
                        100
                      ).toFixed(2) + '%'
                    : '0.00%'
                }})
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作">
            <template slot-scope="scope">
              <el-link type="primary" @click="goto(scope.row)"
                >查看详情</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </basic-block>
</template>

<script>
let echarts = require('echarts')
import { studentCheckRecordStatistics } from '@/http/analysis'
import Bar from '@/views/attendance/analysis/components/bar'
import { mapGetters } from 'vuex'
import { getSchoolTerm } from '@/http/leaveSchool'

export default {
  data() {
    return {
      allStatisticEchart: null,
      gradeStatisticEchart: null,
      barData: {},
      countState: {
        late: 0,
        leave: 0,
        notArrive: 0,
        onTime: 0,
        totalCount: 0,
        studentAmount: 0
      },
      gradeCount: {
        late: [],
        leave: [],
        notArrive: [],
        onTime: []
      },
      tableData: [],
      search: {
        gradeId: '',
        date: [
          new Date(this.$cftY().split(' ')[0] + ' 00:00:00').getTime(),
          new Date(this.$cftY().split(' ')[0] + ' 23:59:59').getTime()
        ],
        campusCode: ''
      },
      currentTerm: {}
    }
  },
  components: {
    Bar
  },
  computed: {
    ...mapGetters(['userInfo', 'allNGrade']),
    allGrade() {
      return [
        {
          gradeCode: '',
          gradeName: '全校'
        },
        ...this.allNGrade
      ]
    },
    allschool() {
      return [...this.allNGrade]
    }
  },
  mounted() {
    this.gradeStatisticEchart = echarts.init(
      document.getElementById('grade_statistic')
    )
  },
  created() {
    this.search.campusCode = this.allschool[0].campusCode
      getSchoolTerm({
        schoolId: this.userInfo.tnId
      }).then((res) => {
        this.currentTerm = res.data
      })
      this.studentCheckRecordStatistics()
  },
  methods: {
    studentCheckRecordStatistics() {
      this.tableData = []
      let search = JSON.parse(JSON.stringify(this.search))
      search.schoolId = this.userInfo.tnId
      if (search.gradeId) {
        search.gradeIds = [search.gradeId]
      }

      studentCheckRecordStatistics(search).then((res) => {
        this.countState = {
          late: 0,
          leave: 0,
          notArrive: 0,
          onTime: 0,
          totalCount: 0,
          studentAmount: 0
        }
        this.gradeCount = {
          late: [],
          leave: [],
          notArrive: [],
          onTime: []
        }
        res.data.forEach((item) => {
          this.countState.late += item.late
          this.countState.leave += item.leave
          this.countState.notArrive += item.notArrive
          this.countState.onTime += item.onTime
          this.countState.totalCount += item.totalCount
          this.countState.studentAmount += item.studentAmount
        })
        this.allNGrade.forEach((item) => {
          console.log(item)
          if (item.campusCode == this.search.campusCode) {
            item.gradeList.forEach((items) => {
              let grades = res.data.filter((i) => i.grade == items.grade)
              if (grades.length > 0) {
                let late = 0,
                  leave = 0,
                  notArrive = 0,
                  onTime = 0,
                  totalCount = 0,
                  studentAmount = 0
                grades.forEach((a) => {
                  late += a.late
                  leave += a.leave
                  notArrive += a.notArrive
                  onTime += a.onTime
                  totalCount += a.totalCount
                  studentAmount += a.studentAmount
                })
                this.gradeCount.late.push(late)
                this.gradeCount.leave.push(leave)
                this.gradeCount.notArrive.push(notArrive)
                this.gradeCount.onTime.push(onTime)
                this.tableData.push({
                  grade: items.grade,
                  late,
                  leave,
                  notArrive,
                  onTime,
                  totalCount,
                  studentAmount,
                  gradeId: items.gradeCode
                })
              } else {
                this.gradeCount.late.push(0)
                this.gradeCount.leave.push(0)
                this.gradeCount.notArrive.push(0)
                this.gradeCount.onTime.push(0)
                this.tableData.push({
                  grade: items.grade,
                  late: 0,
                  leave: 0,
                  notArrive: 0,
                  onTime: 0,
                  totalCount: 0,
                  studentAmount: 0,
                  gradeId: items.gradeCode
                })
              }
            })
          }
        })
        this.setGradeStatisticEchart()
      })
    },
    goto(row) {
      console.log(row)
      console.log(this.search)
      this.$router.push({
        path: '/attendance/gradeStatistic',
        query: {
          ...row,
          startDate: this.search.date[0],
          endDate: this.search.date[1]
        }
      })
    },
    setGradeStatisticEchart() {
      let data = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.$publicConfig.attendanceType,
          bottom: 0
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '40',
          top: '10',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.tableData.map((item) => {
              return item.grade
            })
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: this.$publicConfig.attendanceType[0],
            type: 'bar',
            stack: '广告',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: this.$publicConfig.attendanceTypeColor[0]
            },
            data: this.gradeCount.onTime
          },
          {
            name: this.$publicConfig.attendanceType[1],
            type: 'bar',
            stack: '广告',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: this.$publicConfig.attendanceTypeColor[1]
            },
            barMaxWidth: 40,
            data: this.gradeCount.late
          },
          {
            name: this.$publicConfig.attendanceType[2],
            type: 'bar',
            stack: '广告',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: this.$publicConfig.attendanceTypeColor[2]
            },
            data: this.gradeCount.leave
          },
          {
            name: this.$publicConfig.attendanceType[3],
            type: 'bar',
            stack: '广告',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: this.$publicConfig.attendanceTypeColor[3]
            },
            data: this.gradeCount.notArrive
          }
        ]
      }
      this.gradeStatisticEchart.setOption(data)
    },
    allSchools(e) {
      this.search.campusCode = e
      this.studentCheckRecordStatistics()
    }
  }
}
</script>

<style lang="scss" scoped>
.charts {
  width: 100%;
  height: 391px;
}
</style>